import {
  getMetaTagsDispatchers,
  MetaAttribute,
  MetaAttributeKey,
  MetaAttributeTitle,
  MetaTag,
} from '@owc/connection-aem-meta-tags';
import { TOptions } from 'i18next';
import { useI18n } from './i18n.composable';

// Composable to manage meta tags on a page in an AEM and in a SPA context
export const useMeta = () => {
  const { t, exists } = useI18n();

  // Set meta title to a page
  const updateMetaTitle = (title: string) =>
    Promise.all([
      updateMetaTags([
        {
          attribute: {
            metaValue: 'title',
          },
          content: title,
        },
      ]),
      updateMetaTags([
        {
          attribute: {
            metaValue: 'og:title',
            key: MetaAttributeKey.PROPERTY,
          },
          content: title,
        },
      ]),
    ]);

  // Sets meta title to a value by a given phrase key, but only if key exists
  const updateMetaTitleWithKey = async (key: string, options?: TOptions) => {
    if (exists(key)) await updateMetaTitle(t(key, options) as string);
  };

  // Set meta description to a page
  const updateMetaDescription = (description: string) =>
    Promise.all([
      updateMetaTags([
        {
          attribute: {
            metaValue: 'description',
            key: MetaAttributeKey.NAME,
          },
          content: description,
        },
      ]),
      updateMetaTags([
        {
          attribute: {
            metaValue: 'og:description',
            key: MetaAttributeKey.PROPERTY,
          },
          content: description,
        },
      ]),
    ]);

  // Sets meta description to a value by a given phrase key, but only if key exists
  const updateMetaDescriptionWithKey = async (key: string, options?: TOptions) => {
    if (exists(key)) await updateMetaDescription(t(key, options) as string);
  };

  // Add / update meta tags on a page
  const updateMetaTags = async (metaTags: MetaTag[]) => {
    const dispatchers = await getMetaTagsDispatchers();

    dispatchers.updateMetaTags(metaTags, 'emh');
  };

  return {
    updateMetaTitle,
    updateMetaTitleWithKey,
    updateMetaDescription,
    updateMetaDescriptionWithKey,
    updateMetaTags,
  };
};
